import { get } from "../../service/api";

const GetSettleTransactionSummary = async (merchantId, merchantSettleId, accountNumber = null) => {
    try {
        const params = new URLSearchParams();
        if (accountNumber) params.set("accountNumber", accountNumber);
        const query = params.toString() ? `?${params}` : "";
        const response = await get(`/merchant/${merchantId}/merchantSettle/${merchantSettleId}/transactionSummary${query}`);
        return response;
    } catch (error) {
        console.error('Error GetSettleTransactionSummary:', error);
        throw error;
    }
};

export default GetSettleTransactionSummary;
